import React, { useContext } from "react";
import {
    Toast,
    ToastIcon,
    ToastTitle,
    ToastClose,
} from "@nike/podium";
import SnackbarContext from "../../providers/snackbar-context";

type PodiumStatus = "info" | "success" | "warning" | "critical" | "neutral";

const STATUS_MAP: Record<string, PodiumStatus> = {
    info: "info",
    success: "success",
    warning: "warning",
    error: "critical",
    danger: "critical",
    neutral: "neutral",
};

function ApplicationSnackbar() {
    const snackbarCtx = useContext(SnackbarContext);
    const status: PodiumStatus = STATUS_MAP[snackbarCtx.status] ?? "neutral";

    return (
        <Toast
            open={snackbarCtx.isDisplayed}
            onOpenChange={(open) => { if (!open) snackbarCtx.onClose(); }}
        >
            <ToastIcon status={status} />
            <ToastTitle>{snackbarCtx.msg}</ToastTitle>
            <ToastClose />
        </Toast>
    );
}

export default ApplicationSnackbar;
